import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Row, Statistic, Table, Skeleton, Tag, Space, Button, Tooltip  } from 'antd';
import { bitacoraProcesoNomina, recibosEncabezadoNomina } from '../../../../apis/ProcesoNominaApi';
import { CheckOutlined, CloseOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {status_recibo_nomina} from '@app/constants/reciboNomina';

const App = forwardRef(function AnioPeriodo({header, form, values, disabledForm}, ref) {
    const [info, setInfo] = useState(null);
    const [data, setData] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [periodSelected, setPeriodSelected] = React.useState(null);
    const [bitacoraInfo, setBitacoraInfo] = useState(null);
    const [resumen, setResumen] = useState({
        percepcionTotal: 0,
        deduccionTotal: 0,
        totalNeto: 0,
        numEmpleados: 0,
    });
    const [resumen2, setResumen2] = useState({
        empNeto: 0,
        recibosTimbrados: 0,
        timbradosPrueba: 0,
        timbradosError: 0
    });
   
    useEffect(() => {
        (async () => {
            if(header?.num_periodo > 0){
                await refreshData();
            }
        })();
    }, [header]);

    const refreshData = async (id)=> {
        setLoading(true)
        // Cargar encabezados de recibos
        const responseEncabezado = await recibosEncabezadoNomina(header.periodo_id, header.anio, header.num_periodo);
        if(responseEncabezado.ok){
            let data = responseEncabezado.payload;
            setData(data);
        }

        let data = responseEncabezado.payload;
        let itemsErrorTotal = 0;
        let itemsProcesadoTotal = 0;
        data.forEach(item => {
            if(item.estatus == status_recibo_nomina.ERROR){
                itemsErrorTotal++;
            }
            if(item.estatus == status_recibo_nomina.PROCESADO || item.estatus == status_recibo_nomina.CERRADO || item.estatus == status_recibo_nomina.TIMBRADO){
                itemsProcesadoTotal++;
            }
            
        });
        setBitacoraInfo({
            usuarios_procesados: itemsProcesadoTotal + itemsErrorTotal,
            usuarios_procesados_exito: itemsProcesadoTotal,
            usuarios_procesados_error: itemsErrorTotal,
            usuarios_esperados: data.length
        });
        setResumen2({
            empNeto: 0,
            recibosProcesados: itemsProcesadoTotal,
            timbradosPrueba: 0,
            timbradosError: itemsErrorTotal
        });

        // const response = await bitacoraProcesoNomina(header.periodo_id, header.anio, header.num_periodo);
        // if(response.ok){
        //     let info = response.payload;
        //     setInfo(info);
        // }
        setLoading(false);
    }

    const openDetails = async (object)=>{
        setOpenDetail(true);
        setPeriodSelected(object);
    }

    const columns = [
        {
          title: 'Empleado',
          dataIndex: 'empleado',
          key: 'empleado',
        },
        {
          title: 'Etapa',
          dataIndex: 'estatus',
          key: 'estatus',
          render: (item, object)=> {
            if(object.estatus == status_recibo_nomina.ERROR)
                return  <>
                    <Tag color={'#f50'} key={'error'}>
                        {'Con Error'}
                    </Tag>
                    <Tooltip title={object.error}>
                        <InfoCircleOutlined />
                    </Tooltip>
                </>
    
            if(object.estatus == status_recibo_nomina.EN_PROCESO)
              return  <Tag color={'#2db7f5'} key={'en_proceso'}>
                        {'En proceso'}
                    </Tag>
  
            if(object.estatus == status_recibo_nomina.PROCESADO)
                return  <Tag color={'#87d068'} key={'PROCESADO'}>
                            {'Procesado'}
                        </Tag>
            if(object.estatus == status_recibo_nomina.CERRADO)
                return  <Tag color={'#108ee9'} key={'Cerrado'}>
                            {'Cerrado'}
                        </Tag>

            if(object.estatus == status_recibo_nomina.TIMBRADO)
                return  <Tag color={'purple'} key={'Timbrado'}>
                            {'Timbrado'}
                        </Tag>
  
            return '';
          }
        },
        {
          title: 'Estado',
          dataIndex: 'success',
          key: 'success',
          render: (item, object)=> {
            if(item){
                return <CheckOutlined style={{color:'green'}}/>
            }
            if(!item){
                return <CloseOutlined style={{color:'red'}} />
            }
            return <></>;
          }
        },
        // {
        //     title: '',
        //     dataIndex: 'actions',
        //     key: 'actions',
        //     render: (item, object)=> {
        //       return <Space>
        //       <Button type='primary' size='small' onClick={()=>{
        //           openDetails(object);
        //       }}>Detalles</Button>
        //     </Space>
        //     }
        // }
    ];

    return (
        <>
        {/* Estadísticas de la bitácora */}
        {bitacoraInfo && (
            <Row gutter={16} style={{ paddingTop: 10, paddingBottom: 10 }}>
            <Col span={7} offset={1}>
                <Statistic title="Procesados" value={bitacoraInfo.usuarios_procesados} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} />
            </Col>
            <Col span={7}>
                <Statistic title="Correctos" value={bitacoraInfo.usuarios_procesados_exito} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} prefix={<CheckOutlined style={{ color: 'green' }} />} />
            </Col>
            <Col span={7}>
                <Statistic title="Incorrectos" value={bitacoraInfo.usuarios_procesados_error} suffix={`/ ${bitacoraInfo.usuarios_esperados}`} prefix={<CloseOutlined style={{ color: 'red' }} />} />
            </Col>
            </Row>
        )}
        {/* {
            info && 
            <Row gutter={16} style={{paddingTop: 10, paddingBottom: 10}}>
                <Col span={7} offset={1}>
                    <Statistic title="Procesados" value={info.usuarios_procesados} suffix={`/ ${info.usuarios_esperados}`} />
                </Col>
                <Col span={7}>
                    <Statistic title="Correctos" value={info.usuarios_procesados_exito} suffix={`/ ${info.usuarios_esperados}`}  prefix={<CheckOutlined style={{color:'green'}}/>} />
                </Col>
                <Col span={7}>
                    <Statistic title="Incorrectos" value={info.usuarios_procesados_error} suffix={`/ ${info.usuarios_esperados}`}  prefix={<CloseOutlined style={{color:'red'}}/>}/>
                </Col>
            </Row>
        } */}
        {
        loading ? <Skeleton active={loading} />: <>
            {
                data.length == 0 ? <></>:
                <Table dataSource={data} columns={columns} />
            }
        </>
        }
        </>
    );
});

export default App;
